import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing
import teamDetailsImg from '../../assets/images/team/team-details-img-1.jpg';
import teamDtetailsShape from '../../assets/images/shapes/team-details-name-box-shape.png';
import signIcon from '../../assets/images/shapes/sign.png';

const TeamDetailsMain = () => {
    // Example team member data

    return (
        <React.Fragment>
            {/* Team Details Start */}
            <section className="team-details">
                <div className="container">
                    <div className="team-details__top">
                        <div className="team-details__img">
                            <img src={teamDetailsImg} alt="" />
                        </div>
                        <div className="team-details__content">
                            <div className="team-details__name-and-social-box">
                                <div className="team-details__name-box">
                                    <div className="team-details__name-box-shape">
                                        <img src={teamDtetailsShape} alt="" />
                                    </div>
                                    <h3 className="team-details__name">Wade Warren</h3>
                                    <p className="team-details__sub-title">CEO/Founder</p>
                                </div>
                                <div className="team-details__social">
                                    <Link to="#"><span className="icon-facebook-f"></span></Link>
                                    <Link to="#"><span className="icon-instagram"></span></Link>
                                    <Link to="#"><span className="icon-twitter"></span></Link>
                                    <Link to="#"><span className="icon-linkedin-in"></span></Link>
                                </div>
                            </div>
                            <p className="team-details__top-text">
                                Roof Service is a category that encompasses a range of services related to roofs. These services include roof installation, repair, maintenance, and inspection. Roofing experts provide solutions for various types of roofs, such as shingle, tile, metal, and flat roofs. With their expertise, they ensure the longevity and durability of roofs Roof Service is a category encompasses.
                            </p>
                            <div className="team-details__btn-contact-inner">
                                <div className="team-details__btn-contact">
                                    <div className="team-details__btn-box">
                                        <Link to="/contact" className="team-details__btn thm-btn-two">
                                            Contact <span className="icon-dubble-arrow-right"></span>
                                        </Link>
                                    </div>
                                    <div className="team-details__contact">
                                        <div className="icon">
                                            <span className="icon-call"></span>
                                        </div>
                                        <h3><Link to="tel:01959701730">01959701730</Link></h3>
                                    </div>
                                </div>
                                <div className="team-details__sign">
                                    <img src={signIcon} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="team-details__bottom">
                        <div className="team-details__progress-inner">
                            <h3 className="team-details__progress-title-1">Skills</h3>
                            <div className="row">
                                <div className="col-xl-6 col-lg-6">
                                    <div className="team-details__progress-list">
                                        <ul className="team-details__progress-box list-unstyled">
                                            <li>
                                                <div className="team-details__progress">
                                                    <h4 className="team-details__progress-title">Developing process</h4>
                                                    <div className="bar">
                                                        <div className="bar-inner_one count-bar" data-percent="70%">
                                                            <div className="count-text">70%</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="team-details__progress">
                                                    <h4 className="team-details__progress-title">Market product launch</h4>
                                                    <div className="bar">
                                                        <div className="bar-inner_three count-bar" data-percent="80%">
                                                            <div className="count-text">80%</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6">
                                    <div className="team-details__progress-list team-details__progress-list-2">
                                        <ul className="team-details__progress-box list-unstyled">
                                            <li>
                                                <div className="team-details__progress">
                                                    <h4 className="team-details__progress-title">Management</h4>
                                                    <div className="bar">
                                                        <div className="bar-inner_two count-bar" data-percent="50%">
                                                            <div className="count-text">50%</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="team-details__progress">
                                                    <h4 className="team-details__progress-title">Business Advice</h4>
                                                    <div className="bar">
                                                        <div className="bar-inner_four count-bar" data-percent="90%">
                                                            <div className="count-text">90%</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h3 className="team-details__bottom-title-1">Honors & Awards</h3>
                        <p className="team-details__bottom-text-1">
                            Web designing in a powerful way of just not an only professions, however, in a passion Company. have a tendency to believe the idea that smart-looking any website is the impression on visitors. Web designing in a powerful way only professions Web designing in a powerful way of just not an only profess however in passion Company. have a tendency to believe Roof Service is a category that encompasses a range of services related to roofs.
                        </p>
                    </div>
                </div>
            </section>
            {/* Team Details End */}
        </React.Fragment>
    );
};

export default TeamDetailsMain;
